const categoryData = [
  { name: "Comportement & Utilisation", id: "behaviour" },
  { name: "ENR", id: "renewables" },
  { name: "Enveloppe", id: "casing" },
  { name: "Equipements & Systèmes", id: "equipments" },
  { name: "Etude ingénierie", id: "engineeringstudy" },
  { name: "Marché & Contrat", id: "contracts" },
];
const criticityData = [
  { name: "Faible", id: "weak" },
  { name: "Moyen", id: "medium" },
  { name: "Important", id: "important" },
  { name: "Critique", id: "critical" },
];
const energyType = [
  "electricity",
  "gas",
  "water",
  "heat",
  "cold",
  "fuel",
  "wood",
  "propane",
];

const engineeringstudyedelementsData = [
  { name: "Fluides", id: "energy" },
  { name: "Structures", id: "walls" },
  { name: "Équipements", id: "equipments" },
  {
    name: "Autres",
    id: "others",
  },
];

const unityTypeData = [
  { name: "", id: "equipmentsunit" },
  { name: "Surface", id: "unitsurface" },
  { name: "Surface Utile Brute", id: "brutesurface" },
  {
    name: "Surface SHON",
    id: "shonsurface",
  },
  {
    name: "Surface Plancher",
    id: "planchersurface",
  },
  {
    name: "Volume",
    id: "m3",
  },
];

const unitycountTypeData = [
  { name: "unité (équipement) ", id: "equipmentsunit" },
  { name: "unité/m2 (surface)", id: "unitsurface" },
  { name: "unité/m2 (surface Utile Brute)", id: "brutesurface" },
  {
    name: "unité/m2 (Surface SHON)",
    id: "shonsurface",
  },
  {
    name: "unité/m2 (Surface Plancher)",
    id: "planchersurface",
  },
  {
    name: "unité/m3",
    id: "m3",
  },
];

const unitcostData = [
  { name: "€/unité (équipement) ", id: "equipmentsunit" },
  { name: "€/m2 (surface)", id: "unitsurface" },
  { name: "€/m2 (surface Utile Brute)", id: "brutesurface" },
  {
    name: "€/m2 (Surface SHON)",
    id: "shonsurface",
  },
  {
    name: "€/m2 (Surface Plancher)",
    id: "planchersurface",
  },
  {
    name: "€/m3",
    id: "m3",
  },
];

const equipmentsquantityunitData = [
  { name: "unité (équipement) ", id: "equipmentsunit" },
  { name: "unité/m2 (surface)", id: "unitsurface" },
];

const productioncapacityunitData = [
  { name: "kWh/unité.an (équipement)", id: "yearunit" },
  { name: "kWh/m2.an", id: "yearm2" },
  // { name: "kWc/unité", id: "unit" },
  // { name: "kWc/m2", id: "m2" },
];

const productioncapacitypvunitData = [
  { name: "kWh/unité.an (équipement)", id: "yearunit" },
  { name: "kWh/m2.an", id: "yearm2" },
  { name: "kWh/kWc.an", id: "yearkwc" },
  // { name: "kWc/m2", id: "m2" },
];

const cretepowerunitData = [
  { name: "kWc/unité", id: "unit" },
  { name: "kWc/m2", id: "m2" },
];


const consumptionpartunitData = [
  { name: "%", id: "percent" },
  { name: "%/unité (équipement)", id: "unity" },
  { name: "%/m2", id: "m2" },
];

const investmentcostunitData = [
  { name: "€/unité (équipement)", id: "unit" },
  { name: "€/m2 (surface)", id: "m2" },
  { name: "€/kWh capacité", id: "kwh" },
  // { name: "€/kWc capacité", id: "kwc" },
];

const investmentcostpvunitData = [
  { name: "€/unité (équipement)", id: "unit" },
  { name: "€/m2 (surface)", id: "m2" },
  { name: "€/kWh capacité", id: "kwh" },
  { name: "€/kWc", id: "kwc" },
];

const operationcostunitData = [
  { name: "€/unité (équipement)", id: "unit" },
  { name: "€/m2 (surface)", id: "m2" },
  { name: "€/kWh capacité", id: "kwh" },
  // { name: "€/kWc capacité", id: "kwc" },
];

const operationcostpvunitData = [
  { name: "€/unité (équipement)", id: "unit" },
  { name: "€/m2 (surface)", id: "m2" },
  { name: "€/kWh capacité", id: "kwh" },
  { name: "€/kWc", id: "kwc" },
];

const reclevelData = [
  { name: "Fortement recommandé", id: "high" },
  { name: "Recommandé", id: "medium" },
  { name: "Envisageable", id: "low" },
];

const targetedenergyList = [
  { name: "Electricité", id: "electricity" },
  {
    name: "Gaz",
    id: "gas",
  },
  {
    name: "Eau",
    id: "water",
  },
  { name: "Réseau de chaleur", id: "heat" },
  {
    name: "Réseau frigorifique",
    id: "cold",
  },
  {
    name: "Fioul",
    id: "fuel",
  },
  { name: "Bois", id: "wood" },
  {
    name: "Gaz propane",
    id: "propane",
  },
];

const targetedenergywithoutwaterList = [
  { name: "Electricité", id: "electricity" },
  {
    name: "Gaz",
    id: "gas",
  },
  {
    name: "Eau",
    id: "water",
  },
  { name: "Réseau de chaleur", id: "heat" },
  {
    name: "Réseau frigorifique",
    id: "cold",
  },
  {
    name: "Fioul",
    id: "fuel",
  },
  { name: "Bois", id: "wood" },
  {
    name: "Gaz propane",
    id: "propane",
  },
];

const targetedusageList = {
  electricity: [
    {
      name: "Éclairage",
      id: "lightening",
    },
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Climatisation",
      id: "cooling",
    },
    { name: "Ventilation", id: "ventilation" },
    {
      name: "Autres",
      id: "others",
    },
  ],
  gas: [
    {
      name: "Cuisine",
      id: "cooking",
    },
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Eau chaude sanitaire",
      id: "hotwater",
    },
    {
      name: "Autres",
      id: "others",
    },
  ],
  water: [
    {
      name: "Sanitaire",
      id: "sanitary",
    },
    {
      name: "Arrosage",
      id: "watering",
    },
    { name: "Piscine", id: "pool" },
    {
      name: "Autres",
      id: "others",
    },
  ],
  cold: [
    {
      name: "Climatisation",
      id: "cooling",
    },
    {
      name: "Autres",
      id: "others",
    },
  ],
  heat: [
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Eau chaude sanitaire",
      id: "hotwater",
    },
    {
      name: "Autres",
      id: "others",
    },
  ],
  fuel: [
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Eau chaude sanitaire",
      id: "hotwater",
    },
    {
      name: "Autres",
      id: "others",
    },
  ],
  propane: [
    {
      name: "Cuisine",
      id: "cooking",
    },
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Eau chaude sanitaire",
      id: "hotwater",
    },
    {
      name: "Autres",
      id: "others",
    },
  ],
  wood: [
    {
      name: "Chauffage",
      id: "heat",
    },
    {
      name: "Autres",
      id: "others",
    },
  ]
};

const savingstypeData = [
  { name: "Cumulé", id: "cumulative" },
  {
    name: "Proportionnel",
    id: "proportional",
  },
];

const savingscalculationData = [
  { name: "Valeur caract.", id: "caract" },
  {
    name: "Part de consommation",
    id: "conso",
  },
];

const statusData = [
  { name: "En cours de création", id: "creation" },
  { name: "En attente de démarrage", id: "pending" },
  { name: "En cours", id: "inprogress" },
  { name: "En pause", id: "standby" },
  { name: "Fini", id: "finished" },
];

const savingscalculationList = [
  { name: "Valeur caract.", id: "characteristicvalue" },
  { name: "Part de consommation", id: "consumptionpart" },
];

const subCategoryData = [
  { name: "Ajout", id: "add" },
  { name: "Changement", id: "edit" },
];

const fixedValuesByEnergy = {
  electricity: { co2: 64, euros: 179.8 },
  gas: { co2: 227.0, euros: 75.51 },
  water: { co2: 0.132, euros: 3.98 },
  heat: { co2: 92, euros: 88.1 },
  cold: { co2: 16, euros: 60 },
  propane: { co2: 272.0, euros: 146.5 },
  wood: { co2: 27.0, euros: 62.3 },
  fuel: { co2: 324.0, euros: 75.5 },
};

export {
  categoryData,
  criticityData,
  energyType,
  engineeringstudyedelementsData,
  equipmentsquantityunitData,
  reclevelData,
  unityTypeData,
  unitycountTypeData,
  unitcostData,
  targetedenergyList,
  targetedusageList,
  savingscalculationList,
  savingstypeData,
  subCategoryData,
  statusData,
  savingscalculationData,
  productioncapacityunitData,
  consumptionpartunitData,
  investmentcostunitData,
  operationcostunitData,
  fixedValuesByEnergy,
  targetedenergywithoutwaterList,
  cretepowerunitData,
  productioncapacitypvunitData,
  investmentcostpvunitData,
  operationcostpvunitData,
};
